import { IAppInfo } from "../../interfaces/dto/app.dto";

export enum AppActions {
  APP_SEARCH = "APP_SEARCH",
  APP_SEARCH_SUCCESS = "APP_SEARCH_SUCCESS",
  APP_SEARCH_FAILURE = "APP_SEARCH_FAILURE",
  APP_ADD = "APP_ADD",
  APP_ADD_SUCCESS = "APP_ADD_SUCCESS",
  APP_ADD_FAILURE = "APP_ADD_FAILURE",
  APP_GET_ALL = "APP_GET_ALL",
  APP_GET_ALL_SUCCESS = "APP_GET_ALL_SUCCESS",
  APP_GET_ALL_FAILURE = "APP_GET_ALL_FAILURE",
  APP_DELETE = "APP_DELETE",
  APP_DELETE_SUCCESS = "APP_DELETE_SUCCESS",
  APP_DELETE_FAILURE = "APP_DELETE_FAILURE",
}

interface IDeleteAppAction {
  type: AppActions.APP_DELETE;
}

export const deleteAppAction = (): IDeleteAppAction => ({
  type: AppActions.APP_DELETE,
});

interface IDeleteAppSuccessAction {
  type: AppActions.APP_DELETE_SUCCESS;
  payload: string;
}

export const deleteAppSuccessAction = (
  payload: string,
): IDeleteAppSuccessAction => ({
  type: AppActions.APP_DELETE_SUCCESS,
  payload,
});

interface IDeleteAppFailureAction {
  type: AppActions.APP_DELETE_FAILURE;
  payload: string;
}

export const deleteAppFailureAction = (
  payload: string,
): IDeleteAppFailureAction => ({
  type: AppActions.APP_DELETE_FAILURE,
  payload,
});

interface IGetAllAction {
  type: AppActions.APP_GET_ALL;
}

export const getAllAction = (): IGetAllAction => ({
  type: AppActions.APP_GET_ALL,
});

interface IGetAllSuccessAction {
  type: AppActions.APP_GET_ALL_SUCCESS;
  payload: Array<IAppInfo>;
}

export const getAllSuccessAction = (
  payload: Array<IAppInfo>,
): IGetAllSuccessAction => ({
  type: AppActions.APP_GET_ALL_SUCCESS,
  payload,
});

interface IGetAllFailureAction {
  type: AppActions.APP_GET_ALL_FAILURE;
  payload: string;
}

export const getAllFailureAction = (payload: string): IGetAllFailureAction => ({
  type: AppActions.APP_GET_ALL_FAILURE,
  payload,
});

interface IAddAppAction {
  type: AppActions.APP_ADD;
}

export const addAppAction = (): IAddAppAction => ({
  type: AppActions.APP_ADD,
});

interface IAddAppSuccessAction {
  type: AppActions.APP_ADD_SUCCESS;
  payload: IAppInfo;
}

export const addAppSuccessAction = (
  payload: IAppInfo,
): IAddAppSuccessAction => ({
  type: AppActions.APP_ADD_SUCCESS,
  payload,
});

interface IAddAppFailureAction {
  type: AppActions.APP_ADD_FAILURE;
  payload: string;
}

export const addAppFailureAction = (payload: string): IAddAppFailureAction => ({
  type: AppActions.APP_ADD_FAILURE,
  payload,
});

interface ISearchAction {
  type: AppActions.APP_SEARCH;
}

export const searchAction = (): ISearchAction => ({
  type: AppActions.APP_SEARCH,
});

interface ISearchSuccessAction {
  type: AppActions.APP_SEARCH_SUCCESS;
  payload: Array<IAppInfo>;
}

export const searchSuccessAction = (
  payload: Array<IAppInfo>,
): ISearchSuccessAction => ({
  type: AppActions.APP_SEARCH_SUCCESS,
  payload,
});

interface ISearchFailureAction {
  type: AppActions.APP_SEARCH_FAILURE;
  payload: string;
}

export const searchFailureAction = (payload: string): ISearchFailureAction => ({
  type: AppActions.APP_SEARCH_FAILURE,
  payload,
});

export type IAppAction =
  | ISearchAction
  | ISearchSuccessAction
  | ISearchFailureAction
  | IAddAppAction
  | IAddAppSuccessAction
  | IAddAppFailureAction
  | IGetAllAction
  | IGetAllSuccessAction
  | IGetAllFailureAction
  | IDeleteAppAction
  | IDeleteAppSuccessAction
  | IDeleteAppFailureAction;
